import { useMemo } from 'react'
import { useMediaQuery } from 'react-responsive'

const getBreakpoint = (name: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${name}`).trim()
}

const useBreakpoints = () => {
  const appBreakpoints = useMemo(() => ({
    sm: getBreakpoint('sm'),
    md: getBreakpoint('md'),
    lg: getBreakpoint('lg'),
  }), [])

  const isMobile = useMediaQuery({ query: `(max-width: ${appBreakpoints.sm})` })
  const isTablet = useMediaQuery({ query: `(max-width: ${appBreakpoints.md})` })
  const isDesktop = useMediaQuery({ query: `(max-width: ${appBreakpoints.lg})` })

  return {
    isMobile,
    isTablet,
    isDesktop
  }
}

export default useBreakpoints
